import React, { useMemo } from "react";
import Box from "@mui/material/Box";
import { ProjectsSortOptionsModel } from "../../../models/ProjectResponseModel";
import ComboBox from "../../ComboBox";
import { createAutocompleteOptions } from "../../../utility/utils";

interface ISortOptions {
  filters: ProjectsSortOptionsModel[];
  value: string;
  onChange: (val: string) => void;
}

const SortDropdowns = ({ filters, value, onChange }: ISortOptions) => {
  const projectStatusOptions = useMemo(() => {
    const statusOptions = createAutocompleteOptions(filters, "key", "value");
    statusOptions.unshift({
      value: "all",
      label: "All",
    });
    return statusOptions;
  }, [filters]);

  const handleOnChange = (value: string | number) => {
    if (typeof value === "number") {
      value = value.toString();
    }
    onChange(value);
  };

  return (
    <ComboBox
      options={projectStatusOptions}
      disableClearable
      value={value}
      label="Project Status"
      placeholder="Project Status"
      onChange={handleOnChange}
    />
  );
};

const SortingSection = ({ filters, value, onChange }: ISortOptions) => {
  return (
    <Box>
      <SortDropdowns filters={filters} value={value} onChange={onChange} />
    </Box>
  );
};

export default SortingSection;
